var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"db-layout":"sidebar-wrapper"}},[_c('side-bar',{attrs:{"db-layout":"sidebar-left"}}),_c('div',{staticClass:"d-flex flex-column",attrs:{"db-layout":"sidebar-right"}},[_c('main-header',{attrs:{"title":_vm.title,"version":_vm.version,"icon":_vm.icon}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }